(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["m2-slab-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('m2-slab-finder')) return;

    const PARAMS = { w: 'width', t: 'thickness', l: 'length', p: 'price' };

    const num = (value) => {
      const n = parseFloat(value);
      return Number.isFinite(n) ? n : null;
    };

    const tidy = (n) => String(Math.round(n * 100) / 100);

    const feet = (inches) => {
      const total = Math.round(inches);
      const ft = Math.floor(total / 12);
      const rest = total - ft * 12;
      return rest ? ft + ' ft ' + rest + ' in' : ft + ' ft';
    };

    class M2SlabFinder extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      setup() {
        if (this.ready) return;
        this.ready = true;

        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;

        const seen = new Set();
        this.items = [];
        this.grid.querySelectorAll('[data-slab]').forEach((el) => {
          if (seen.has(el.dataset.id)) {
            el.remove();
            return;
          }
          seen.add(el.dataset.id);
          this.items.push({
            el,
            order: this.items.length,
            w: num(el.dataset.w),
            t: num(el.dataset.t),
            l: num(el.dataset.l),
            p: num(el.dataset.price),
            g: el.dataset.group || '',
            e: el.dataset.edge || '',
            bm: el.hasAttribute('data-bookmatched'),
          });
        });
        if (!this.items.length) return;
        this.sorted = this.items.slice();

        this.pageSize = parseInt(this.dataset.pageSize, 10) || 0;
        this.shown = this.pageSize;
        this.one = this.dataset.nounOne || 'slab';
        this.many = this.dataset.nounMany || 'slabs';
        this.sort = 'featured';

        try {
          this.money = new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
            maximumFractionDigits: 0,
          });
        } catch (error) {
          this.money = null;
        }

        this.countEl = this.querySelector('[data-count]');
        this.emptyEl = this.querySelector('[data-empty]');
        this.moreWrap = this.querySelector('[data-more-wrap]');
        this.moreBtn = this.querySelector('[data-more]');
        this.allBtn = this.querySelector('[data-all]');
        this.badge = this.querySelector('[data-active-count]');
        this.sortEl = this.querySelector('[data-sort]');
        this.panel = this.querySelector('[data-panel]');

        this.setupRanges();
        this.setupFacets();
        this.setupFlag();

        this.querySelectorAll('[data-clear]').forEach((button) => {
          button.addEventListener('click', () => this.clear());
        });

        if (this.sortEl) {
          // Drop the width and length sort choices when no item has that size recorded.
          Array.from(this.sortEl.options).forEach((option) => {
            const key = option.value.split('-')[0];
            if ((key === 'w' || key === 'l') && !this.items.some((item) => item[key] !== null)) {
              option.remove();
            }
          });

          this.sortEl.addEventListener('change', () => {
            this.sort = this.sortEl.value;
            this.shown = this.pageSize;
            this.reorder();
            this.apply(true);
          });
        }

        if (this.moreBtn) {
          this.moreBtn.addEventListener('click', () => {
            this.shown += this.pageSize;
            this.apply(false);
          });
        }

        if (this.allBtn) {
          this.allBtn.addEventListener('click', () => {
            this.shown = this.items.length;
            this.apply(false);
          });
        }

        if (this.panel) {
          const wide = window.matchMedia('(min-width: 990px)');
          const syncPanel = () => {
            this.panel.open = wide.matches;
          };
          syncPanel();
          wide.addEventListener('change', syncPanel);
        }

        const restored = this.readUrl();
        this.ranges.forEach((range) => this.paint(range));
        if (this.sort !== 'featured') this.reorder();
        this.apply(false);

        const plain = this.ranges.length === 0 && this.facets.length === 0 && !this.flagEl;
        const aside = this.querySelector('[data-aside]');
        const layout = this.querySelector('.m2-slab-finder__layout');
        const toolbar = this.querySelector('[data-toolbar]');
        if (aside) aside.hidden = plain;
        if (layout) layout.classList.toggle('m2-slab-finder__layout--plain', plain);
        if (toolbar) toolbar.hidden = false;

        // A shared link that carries filters opens at the finder, not the top of the page.
        if (restored && !window.location.hash) {
          const jump = () => window.setTimeout(() => this.scrollIntoView({ block: 'start' }), 150);
          if (document.readyState === 'complete') {
            jump();
          } else {
            window.addEventListener('load', jump, { once: true });
          }
        }
      }

      setupRanges() {
        this.ranges = [];
        this.querySelectorAll('[data-range]').forEach((box) => {
          const key = box.dataset.range;
          const values = this.items.map((item) => item[key]).filter((value) => value !== null);
          if (!values.length) return;

          const step = parseFloat(box.dataset.step) || 1;
          const min = Math.floor(Math.min(...values) / step + 1e-9) * step;
          const max = Math.ceil(Math.max(...values) / step - 1e-9) * step;
          // Skip a slider with fewer than three positions: the slabs barely differ on it.
          if (max - min < step * 1.5) return;

          const inputs = box.querySelectorAll('input[type=range]');
          const range = {
            key,
            box,
            step,
            min,
            max,
            lo: min,
            hi: max,
            // Length in half-foot or whole-foot steps reads in feet (10 ft, 10.5 ft).
            inFeet: key === 'l' && step >= 6 && step % 6 === 0,
            loEl: inputs[0],
            hiEl: inputs[1],
            valueEl: box.querySelector('[data-value]'),
            noteEl: box.querySelector('[data-note]'),
          };

          [range.loEl, range.hiEl].forEach((input) => {
            input.min = min;
            input.max = max;
            input.step = step;
          });
          range.loEl.value = min;
          range.hiEl.value = max;

          const onInput = (event) => {
            let lo = parseFloat(range.loEl.value);
            let hi = parseFloat(range.hiEl.value);
            if (lo > hi) {
              if (event.target === range.loEl) {
                lo = hi;
                range.loEl.value = lo;
              } else {
                hi = lo;
                range.hiEl.value = hi;
              }
            }
            range.lo = lo;
            range.hi = hi;
            this.paint(range);
            this.shown = this.pageSize;
            this.apply(true);
          };
          range.loEl.addEventListener('input', onInput);
          range.hiEl.addEventListener('input', onInput);

          box.hidden = false;
          this.ranges.push(range);
        });
      }

      setupFacets() {
        // Checkbox lists: category or species (item.g) and edge type (item.e).
        // A list only shows when the items carry at least two different values.
        this.facets = [];
        this.querySelectorAll('[data-facet]').forEach((wrap) => {
          const key = wrap.dataset.facet;
          const names = [];
          this.items.forEach((item) => {
            if (item[key] && !names.includes(item[key])) names.push(item[key]);
          });
          if (names.length < 2) return;
          if (wrap.hasAttribute('data-sorted')) names.sort((a, b) => a.localeCompare(b));

          const facet = { key, param: wrap.dataset.param || key, selected: new Set(), options: [] };
          const list = wrap.querySelector('[data-facet-list]');
          names.forEach((name) => {
            const label = document.createElement('label');
            label.className = 'm2-sf-check';
            const input = document.createElement('input');
            input.type = 'checkbox';
            input.value = name;
            const text = document.createElement('span');
            text.textContent = name;
            const count = document.createElement('span');
            count.className = 'm2-sf-check__count';
            label.append(input, text, count);
            list.appendChild(label);

            input.addEventListener('change', () => {
              if (input.checked) {
                facet.selected.add(name);
              } else {
                facet.selected.delete(name);
              }
              this.shown = this.pageSize;
              this.apply(true);
            });
            facet.options.push({ name, input, count, label });
          });
          wrap.hidden = false;
          this.facets.push(facet);
        });
      }

      setupFlag() {
        // "Bookmatched sets only" checkbox: shown only when a bookmatched set is in the list.
        this.flagEl = null;
        this.flagOn = false;
        const wrap = this.querySelector('[data-flag-wrap]');
        if (!wrap || !this.items.some((item) => item.bm)) return;

        this.flagEl = wrap.querySelector('[data-flag]');
        this.flagCount = wrap.querySelector('[data-flag-count]');
        this.flagEl.addEventListener('change', () => {
          this.flagOn = this.flagEl.checked;
          this.shown = this.pageSize;
          this.apply(true);
        });
        wrap.hidden = false;
      }

      label(range, value) {
        if (range.key === 'p') {
          return this.money ? this.money.format(value) : '$' + tidy(value);
        }
        if (range.inFeet) return tidy(value / 12) + ' ft';
        return tidy(value) + ' in';
      }

      paint(range) {
        const span = range.max - range.min;
        range.box.style.setProperty('--lo', (range.lo - range.min) / span);
        range.box.style.setProperty('--hi', (range.hi - range.min) / span);
        // Keep whichever handle can still move on top when the two meet.
        range.loEl.style.zIndex = range.lo - range.min > span / 2 ? 4 : 2;
        range.hiEl.style.zIndex = 3;

        const lo = this.label(range, range.lo);
        const hi = this.label(range, range.hi);
        range.valueEl.textContent = lo + ' – ' + hi;
        range.loEl.setAttribute('aria-valuetext', lo);
        range.hiEl.setAttribute('aria-valuetext', hi);
        if (range.noteEl && range.key === 'l') {
          // Under the length slider: the same range in the other unit.
          range.noteEl.textContent = range.inFeet
            ? tidy(range.lo) + ' in – ' + tidy(range.hi) + ' in'
            : feet(range.lo) + ' – ' + feet(range.hi);
        }
      }

      isActive(range) {
        return range.lo > range.min || range.hi < range.max;
      }

      reorder() {
        const parts = this.sort.split('-');
        const key = parts[0];
        const direction = parts[1] === 'desc' ? -1 : 1;
        const list = this.items.slice();

        if (PARAMS[key]) {
          list.sort((a, b) => {
            const x = a[key];
            const y = b[key];
            if (x === null && y === null) return a.order - b.order;
            if (x === null) return 1;
            if (y === null) return -1;
            return (x - y) * direction || a.order - b.order;
          });
        }

        this.sorted = list;
        list.forEach((item) => this.grid.appendChild(item.el));
      }

      apply(writeUrl) {
        const active = this.ranges.filter((range) => this.isActive(range));
        const inRanges = (item) =>
          active.every((range) => {
            const value = item[range.key];
            return value !== null && value >= range.lo - 1e-9 && value <= range.hi + 1e-9;
          });
        // True when the item passes every checkbox list, optionally leaving one list out.
        const inFacets = (item, skip) =>
          this.facets.every(
            (facet) => facet === skip || !facet.selected.size || facet.selected.has(item[facet.key])
          );

        const tallies = new Map();
        this.facets.forEach((facet) => tallies.set(facet, {}));
        const passing = [];
        let flagged = 0;
        this.sorted.forEach((item) => {
          const sized = inRanges(item);
          const flagOk = !this.flagOn || item.bm;
          const grouped = inFacets(item, null);
          if (sized && flagOk) {
            this.facets.forEach((facet) => {
              if (!inFacets(item, facet)) return;
              const tally = tallies.get(facet);
              const name = item[facet.key];
              tally[name] = (tally[name] || 0) + 1;
            });
          }
          if (sized && grouped && item.bm) flagged += 1;
          if (sized && grouped && flagOk) {
            passing.push(item);
          } else {
            item.el.hidden = true;
          }
        });
        if (this.flagCount) this.flagCount.textContent = String(flagged);

        passing.forEach((item, index) => {
          item.el.hidden = this.pageSize > 0 && index >= this.shown;
        });

        const total = this.items.length;
        const found = passing.length;
        const picked = this.facets.filter((facet) => facet.selected.size > 0).length;
        const filtered = active.length > 0 || picked > 0 || this.flagOn;

        if (this.countEl) {
          this.countEl.textContent = filtered
            ? found + ' ' + (found === 1 ? this.one : this.many) + ' found'
            : total + ' ' + (total === 1 ? this.one : this.many);
        }

        if (this.emptyEl) this.emptyEl.hidden = found > 0;

        const remaining = this.pageSize > 0 ? Math.max(0, found - this.shown) : 0;
        if (this.moreWrap) {
          this.moreWrap.hidden = remaining === 0;
          if (this.moreBtn) this.moreBtn.textContent = 'Show ' + Math.min(this.pageSize, remaining) + ' more';
          if (this.allBtn) {
            this.allBtn.textContent = 'Show all ' + found;
            this.allBtn.hidden = remaining <= this.pageSize;
          }
        }

        this.querySelectorAll('[data-clear]').forEach((button) => {
          button.hidden = !filtered;
        });

        if (this.badge) {
          const used = active.length + picked + (this.flagOn ? 1 : 0);
          this.badge.textContent = used ? '(' + used + ')' : '';
        }

        this.facets.forEach((facet) => {
          const tally = tallies.get(facet);
          facet.options.forEach((option) => {
            const matches = tally[option.name] || 0;
            option.count.textContent = String(matches);
            option.label.classList.toggle('m2-sf-check--none', matches === 0 && !option.input.checked);
          });
        });

        if (writeUrl) {
          clearTimeout(this.urlTimer);
          this.urlTimer = setTimeout(() => this.writeUrl(), 300);
        }
      }

      clear() {
        this.ranges.forEach((range) => {
          range.lo = range.min;
          range.hi = range.max;
          range.loEl.value = range.min;
          range.hiEl.value = range.max;
          this.paint(range);
        });
        this.facets.forEach((facet) => {
          facet.selected.clear();
          facet.options.forEach((option) => {
            option.input.checked = false;
          });
        });
        this.flagOn = false;
        if (this.flagEl) this.flagEl.checked = false;
        this.shown = this.pageSize;
        this.apply(true);
      }

      readUrl() {
        const params = new URLSearchParams(window.location.search);
        let restored = false;

        this.ranges.forEach((range) => {
          const raw = params.get(PARAMS[range.key]);
          if (!raw) return;
          const parts = raw.split('-');
          let lo = parseFloat(parts[0]);
          let hi = parseFloat(parts[1]);
          if (!Number.isFinite(lo)) lo = range.min;
          if (!Number.isFinite(hi)) hi = range.max;
          lo = Math.min(Math.max(lo, range.min), range.max);
          hi = Math.min(Math.max(hi, lo), range.max);
          range.loEl.value = lo;
          range.hiEl.value = hi;
          range.lo = parseFloat(range.loEl.value);
          range.hi = parseFloat(range.hiEl.value);
          if (this.isActive(range)) restored = true;
        });

        this.facets.forEach((facet) => {
          const raw = params.get(facet.param);
          if (!raw) return;
          raw.split(',').forEach((name) => {
            const option = facet.options.find((entry) => entry.name === name);
            if (!option) return;
            option.input.checked = true;
            facet.selected.add(name);
            restored = true;
          });
        });

        if (this.flagEl && params.get('bookmatched') === '1') {
          this.flagEl.checked = true;
          this.flagOn = true;
          restored = true;
        }

        const sort = params.get('sort');
        if (sort && this.sortEl && Array.from(this.sortEl.options).some((option) => option.value === sort)) {
          this.sort = sort;
          this.sortEl.value = sort;
        }

        return restored;
      }

      writeUrl() {
        const url = new URL(window.location.href);
        this.ranges.forEach((range) => {
          const name = PARAMS[range.key];
          if (this.isActive(range)) {
            url.searchParams.set(name, tidy(range.lo) + '-' + tidy(range.hi));
          } else {
            url.searchParams.delete(name);
          }
        });

        this.facets.forEach((facet) => {
          if (facet.selected.size) {
            url.searchParams.set(facet.param, Array.from(facet.selected).join(','));
          } else {
            url.searchParams.delete(facet.param);
          }
        });

        if (this.flagOn) {
          url.searchParams.set('bookmatched', '1');
        } else {
          url.searchParams.delete('bookmatched');
        }

        if (this.sort !== 'featured') {
          url.searchParams.set('sort', this.sort);
        } else {
          url.searchParams.delete('sort');
        }

        window.history.replaceState(window.history.state, '', url);
      }
    }

    customElements.define('m2-slab-finder', M2SlabFinder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
